import { render } from "./stripeForm.vue?vue&type=template&id=52107207&scoped=true&ts=true"
import script from "./stripeForm.vue?vue&type=script&lang=ts"
export * from "./stripeForm.vue?vue&type=script&lang=ts"

import "./stripeForm.vue?vue&type=style&index=0&id=52107207&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52107207"]])

export default __exports__